import 'Assets/styles/index.scss';
import ReactOnRails from 'react-on-rails';
import App from 'Containers/App/Entry';

ReactOnRails.register({ App });
